(() => {
  const root = document.querySelector('[data-support-funnel]');
  if (!root) return;

  const triggers = Array.from(document.querySelectorAll('a[href*="/pages/contacto?support=1"]'));
  if (!triggers.length) return;

  const dialog = root.querySelector('[role="dialog"]');
  const steps = Array.from(root.querySelectorAll('[data-support-step]'));
  const progress = root.querySelector('[data-support-progress]');
  const stepLabel = root.querySelector('[data-support-step-label]');
  const detailQuestion = root.querySelector('[data-support-detail-question]');
  const detailOptions = root.querySelector('[data-support-detail-options]');
  const summary = root.querySelector('[data-support-summary]');
  const whatsappLink = root.querySelector('[data-support-whatsapp]');
  const backButton = root.querySelector('[data-support-back]');
  const restartButton = root.querySelector('[data-support-restart]');
  const answers = {};
  const answerLabels = {};
  let currentStep = 1;
  let lastFocus = null;

  const equipmentDetails = {
    roaster: {
      question: '¿Qué familia de tostadora tienes?',
      options: [
        ['kaleido', 'Kaleido', 'Tostadoras Kaleido Sniper.'],
        ['smola', 'Smola', 'Tostadoras Smola de aire o tambor.'],
        ['skywalker', 'Skywalker', 'Tostadoras Skywalker.'],
        ['home_manual', 'Doméstica o manual', 'Tostadora doméstica, automática o manual.'],
        ['other_roaster', 'Otra o no estoy seguro', 'Te ayudaremos a identificarla.'],
      ],
    },
    grinder: {
      question: '¿Qué tipo de molino tienes?',
      options: [
        ['grinder_64', 'Molino de 64 mm', 'Modelos profesionales con muelas de 64 mm.'],
        ['grinder_90', 'Molino de 90 mm', 'Modelos profesionales con muelas de 90 mm.'],
        ['grinder_98', 'Molino de 98 mm', 'Modelos profesionales con muelas de 98 mm.'],
        ['other_grinder', 'Otro o no sé el modelo', 'Te ayudaremos a identificarlo.'],
      ],
    },
    other_equipment: {
      question: '¿Qué tipo de equipo tienes?',
      options: [
        ['espresso', 'Máquina de espresso', 'Equipo para preparación de espresso.'],
        ['lab', 'Equipo de laboratorio', 'Medición, análisis o control de calidad.'],
        ['accessory', 'Accesorio u otro equipo', 'Otro producto o componente.'],
        ['unknown_equipment', 'No estoy seguro', 'Te ayudaremos a identificarlo.'],
      ],
    },
  };

  const track = (eventName, extra = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      source: 'hrc_support_funnel',
      ...extra,
    });
  };

  const showStep = (step) => {
    currentStep = step;
    steps.forEach((item) => {
      item.hidden = item.dataset.supportStep !== String(step);
    });

    const isResult = step === 'result';
    progress.style.width = isResult ? '100%' : `${(Number(step) / 3) * 100}%`;
    stepLabel.textContent = isResult ? 'Solicitud lista' : `Paso ${step} de 3`;
    backButton.hidden = step === 1 || isResult;
    restartButton.hidden = !isResult;

    const heading = root.querySelector(`[data-support-step="${step}"] h3`);
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  };

  const makeDetailButton = ([value, label, description]) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.supportDetail = 'true';
    button.dataset.value = value;
    button.dataset.label = label;

    const strong = document.createElement('strong');
    strong.textContent = label;
    const span = document.createElement('span');
    span.textContent = description;
    button.append(strong, span);
    return button;
  };

  const renderDetails = (equipment) => {
    const details = equipmentDetails[equipment];
    if (!details) return;
    detailQuestion.textContent = details.question;
    detailOptions.replaceChildren(...details.options.map(makeDetailButton));
  };

  const buildResult = () => {
    summary.replaceChildren();
    Object.values(answerLabels).forEach((label) => {
      const chip = document.createElement('span');
      chip.textContent = label;
      summary.appendChild(chip);
    });

    const messageLines = [
      'Hola, necesito soporte de Home Roaster Chile.',
      `Equipo o solicitud: ${answerLabels.equipment}.`,
    ];
    if (answerLabels.detail) messageLines.push(`Familia o tipo: ${answerLabels.detail}.`);
    messageLines.push(`Ayuda requerida: ${answerLabels.issue}.`);
    messageLines.push('¿Me pueden orientar? Puedo enviar fotos, videos o el número de pedido si lo necesitan.');

    whatsappLink.href = `https://wa.me/${root.dataset.whatsappNumber}?text=${encodeURIComponent(messageLines.join('\n'))}`;
    showStep('result');
    track('support_funnel_complete', {
      equipment_type: answers.equipment,
      equipment_detail: answers.detail || 'not_applicable',
      support_type: answers.issue,
    });
  };

  const selectAnswer = (button) => {
    const key = button.dataset.key;
    answers[key] = button.dataset.value;
    answerLabels[key] = button.dataset.label;
    track('support_funnel_answer', {
      step: currentStep,
      question: key,
      answer: button.dataset.value,
    });

    if (key === 'equipment') {
      delete answers.detail;
      delete answerLabels.detail;
      if (answers.equipment === 'other_support') {
        showStep(3);
      } else {
        renderDetails(answers.equipment);
        showStep(2);
      }
    } else if (key === 'issue') {
      buildResult();
    }
  };

  const open = (event) => {
    event.preventDefault();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('machine-finder-open');
    showStep(1);
    track('support_funnel_open', {
      placement: event.currentTarget.dataset.supportPlacement || 'homepage_hero',
    });
  };

  const close = () => {
    root.hidden = true;
    document.body.classList.remove('machine-finder-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  triggers.forEach((trigger) => trigger.addEventListener('click', open));

  root.querySelectorAll('[data-support-close]').forEach((button) => {
    button.addEventListener('click', close);
  });

  root.querySelectorAll('[data-support-answer]').forEach((button) => {
    button.addEventListener('click', () => selectAnswer(button));
  });

  detailOptions.addEventListener('click', (event) => {
    const button = event.target.closest('[data-support-detail]');
    if (!button) return;
    answers.detail = button.dataset.value;
    answerLabels.detail = button.dataset.label;
    track('support_funnel_answer', {
      step: 2,
      question: 'equipment_detail',
      answer: button.dataset.value,
    });
    showStep(3);
  });

  backButton.addEventListener('click', () => {
    if (currentStep === 3 && answers.equipment === 'other_support') {
      showStep(1);
    } else {
      showStep(Math.max(1, currentStep - 1));
    }
  });

  restartButton.addEventListener('click', () => {
    Object.keys(answers).forEach((key) => delete answers[key]);
    Object.keys(answerLabels).forEach((key) => delete answerLabels[key]);
    showStep(1);
    track('support_funnel_restart');
  });

  whatsappLink.addEventListener('click', () => {
    track('support_funnel_whatsapp_click', {
      equipment_type: answers.equipment,
      equipment_detail: answers.detail || 'not_applicable',
      support_type: answers.issue,
      placement: 'support_funnel_result',
    });
  });

  document.addEventListener('keydown', (event) => {
    if (root.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      dialog.querySelectorAll('a[href], button:not([hidden]):not([disabled]), [tabindex="0"]'),
    ).filter((element) => !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
